import React  from 'react';
import { DarkTooltip } from '../tooltips';
import { PrimaryButtonLarge } from '../buttons';

export default function RamsCreationActions(props) {
  const { formValues, handleNext } = props;
  const { roles, quantityCreated } = formValues;

  const checkedRoles = roles.filter(role => role.checked);

  const validRoles = checkedRoles.every(role => role.timeCreating !== null);

  const isNextEnabled = quantityCreated && validRoles;

  return (
    <DarkTooltip
      arrow
      disableFocusListener={isNextEnabled}
      disableHoverListener={isNextEnabled}
      disableTouchListener={isNextEnabled}
      title='Please complete all fields to continue'
      placement='top'
    >
      <span>
        <PrimaryButtonLarge disableRipple={true} disableFocusRipple={true} disabled={!isNextEnabled} onClick={handleNext}>Next</PrimaryButtonLarge>
      </span>
    </DarkTooltip>
  )
}
